import React, { useEffect, useRef, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { isMobile } from "react-device-detect";
import {
  MenuHolder,
  Menu,
  MenuLines,
  MenuLine,
  MenuItems,
  MenuItem,
  OffShort,
  OffShortTwoColumns,
  OffShortOneColumn,
  OffFullBanner,
  Assinatura,
  H1,
  OffShortContent0,
  Link,
  OffShortLogo,
  OffFull,
  OffFullTitle,
  OffFullThree,
  OffFullThreeItem,
  OffFullThreeItemTitle,
  OffFullThreeItemContent,
  H2,
  OffShortImages,
  OffFullThreeItemLink,
} from "./style";
import logoSaintGobainHorizontal from "../../../../assets/images/logo-cidade-virtual-new-horizontal.png";
import img1 from "../../../../assets/images/Imagem 1.png";
import img2 from "../../../../assets/images/Imagem 2.png";
import logoIsover from "../../../../assets/images/Logo Isover.png";
import logoPlaco from "../../../../assets/images/Logo Placo.png";
import logoWeber from "../../../../assets/images/Logo Weber.png";
import logoClimalit from "../../../../assets/images/Logo Climalit.png";

const BurgerMenu = ({ burgerMenuOn, setBurgerMenuOn }) => {
  const menuRef = useRef(null);
  let navigate = useNavigate();

  const checkMenu = (e) => {
    setBurgerMenuOn(e.target.checked);
  };

  const goTo = (section) => {
    navigate(section);
    menuRef.current.checked = false;
    setBurgerMenuOn(false);
  };

  const sharePage = () => {};

  return (
    <MenuHolder className={isMobile && "mobile"}>
      <Menu onChange={checkMenu} ref={menuRef} />
      <MenuLines className={`${burgerMenuOn && "on"} ${isMobile && "mobile"}`}>
        <MenuLine />
        <MenuLine />
        <MenuLine />
      </MenuLines>
      <Offcanvas
        show={burgerMenuOn}
        placement={isMobile ? "bottom" : "end"}
        style={{ maxWidth: "1024px" }}
      >
        <Offcanvas.Body style={{ padding: "0px" }}>
          <OffShort>
            <OffFullBanner>
              <img src={logoSaintGobainHorizontal} alt="Logo Saint Gobain" />
              <Assinatura>Juntos, construímos as cidades do futuro.</Assinatura>
            </OffFullBanner>
            <OffShortOneColumn>
              <OffShortContent0>
                <H1>Explora a Cidade Virtual Saint-Gobain</H1>A Cidade Virtual
                da Saint-Gobain Portugal reflete a integração das marcas{" "}
                <b>Isover, Placo®, Weber, Saint-Gobain Glass e Climalit®</b>,
                baseada no nosso propósito – Making the World a Better Home.
                <br />
                <br />
                As cidades inteligentes não são apenas um conceito do futuro.
                Acreditamos que as cidades devem ser reinventadas, priorizando{" "}
                <b>a segurança, a qualidade e o bem-estar</b> das pessoas e
                gerações futuras.
                <br />
                <br />
                <H2>Produtos e soluções para Construção</H2>
                Encontra de forma interativa uma variedade de soluções
                específicas e adaptadas para projetos em{" "}
                <b>diferentes tipologias de edifícios</b>, tais como edifícios
                residenciais, industriais, hospitais, hotéis, escritórios,
                escolas e centros comerciais.
                <br />
                <br />
                As soluções Saint-Gobain não só se complementam, como também
                traduzem a nossa forte aposta na{" "}
                <b>inovação e sustentabilidade</b>.
                <OffShortImages>
                  <img src={img2} alt="Detalhes produtos" />
                </OffShortImages>
                <H2>
                  Construção leve e sustentável, uma tendência e necessidade do
                  setor
                </H2>
                Assistimos ao crescimento de uma população cada vez mais urbana
                e ao aumento da consciência sobre o{" "}
                <b>impacto do setor da construção</b> no clima, nos recursos
                naturais e na saúde.
                <br />
                <br />
                Este impacto obriga a uma urgente mudança, de modo a criar{" "}
                <b>espaços mais cómodos, rentáveis e sustentáveis</b> em todo o
                mundo.
                <br />
                <br />
                Os edifícios devem ser projetados de forma eficiente desde o
                início. <b>Contribuir para um mundo mais sustentável</b>, com o
                mínimo impacto possível para o planeta é o nosso maior
                compromisso.
                <br />
                <br />
                <OffShortImages>
                  <img src={img1} alt="Detalhes de produtos aplicados" />
                </OffShortImages>
                <H2>Sobre as nossas marcas</H2>
                <OffShortLogo>
                  <img src={logoIsover} alt="Logo Isover" />
                </OffShortLogo>
                A Isover é referência em soluções de lã mineral de vidro e lã de
                rocha para <b>isolamento térmico e acústico</b>, bem como{" "}
                <b>proteção contra o fogo</b> em edifícios.
                <OffShortLogo>
                  <img src={logoPlaco} alt="Logo Placo" />
                </OffShortLogo>
                A Placo® oferece soluções à base de gesso para{" "}
                <b>sistemas com placas de gesso</b>. Comprometida no
                desenvolvimento de soluções diferenciadoras para construção a
                seco - drywall.
                <OffShortLogo>
                  <img src={logoWeber} alt="Logo Weber" />
                </OffShortLogo>
                A Weber é dedicada a soluções inovadoras baseadas em argamassas
                industriais para áreas como <b>colagem e betumação</b> de
                cerâmica, revestimento e isolamento de{" "}
                <b>fachadas, impermeabilização, coberturas e pavimentos</b>.
                <OffShortLogo>
                  <img src={logoClimalit} alt="Logo Climalit" />
                </OffShortLogo>
                Já a marca Climalit® é <b>líder em vidro duplo</b> em Portugal.
                As suas soluções de vidro permitem obter um nível de{" "}
                <b>isolamento térmico até 3 vezes superior</b> em relação a uma
                solução padrão.
              </OffShortContent0>
            </OffShortOneColumn>
          </OffShort>
          <OffFull>
            <OffFullThree>
              <OffFullThreeItem>
                <OffFullThreeItemTitle>Sistemas</OffFullThreeItemTitle>
                <OffFullThreeItemContent>
                  Desenvolvemos sistemas construtivos para as várias atividades
                  de construção.
                </OffFullThreeItemContent>
                <OffFullThreeItemLink
                  aria-labelledby="Link sistemas"
                  href="https://www.saint-gobain.pt/sistemas"
                  target="_blank"
                >
                  Saber mais
                </OffFullThreeItemLink>
              </OffFullThreeItem>
              <OffFullThreeItem>
                <OffFullThreeItemTitle>Documentação</OffFullThreeItemTitle>
                <OffFullThreeItemContent>
                  Sabe mais sobre as nossas soluções, Objetos BIM e desenhos
                  CAD.
                </OffFullThreeItemContent>
                <OffFullThreeItemLink
                  aria-labelledby="Link serviços"
                  href="https://www.saint-gobain.pt/servicos"
                  target="_blank"
                >
                  Descobrir serviços
                </OffFullThreeItemLink>
              </OffFullThreeItem>
              <OffFullThreeItem>
                <OffFullThreeItemTitle>Blog</OffFullThreeItemTitle>
                <OffFullThreeItemContent>
                  Acompanha as nossas dicas, artigos de opinião e novidades no
                  Mundo Saint-Gobain.
                </OffFullThreeItemContent>
                <OffFullThreeItemLink
                  aria-labelledby="Link blog"
                  href="https://www.saint-gobain.pt/blog"
                  target="_blank"
                >
                  Ver artigos
                </OffFullThreeItemLink>
              </OffFullThreeItem>
            </OffFullThree>
          </OffFull>
        </Offcanvas.Body>
      </Offcanvas>
    </MenuHolder>
  );
};

export default BurgerMenu;
